<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-container style="height: 100%" class="align-center">
        <h2>Usuarios</h2>

        <h3 class="mt-4 mb-4">
          Indica quién administrará y comprará con Mangxo. Podrás agregar más
          usuarios una vez aprobada tu cuenta.
        </h3>
        <h3 class="mt-4 mb-4">
          Se enviara al correo la respuesta de la solicitud y las credenciales
          para ingresar a la plataforma.
        </h3>

        <v-divider class="my-6"></v-divider>
        <h4>Usuario Comprador (Obligatorio)</h4>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.buyer_name"
              label="Nombre completo del comprador"
              :rules="rules.required"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.buyer_last_name"
              label="Apellido del comprador"
              :rules="rules.required"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.buyer_email"
              label="Email del comprador"
              :rules="rules.email"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.buyer_phone"
              label="Teléfono del comprador"
              :rules="rules.phone"
              filled
              autocomplete="off"
              maxlength="10"
              @focus="onFocus"
            >
              <template v-slot:prepend-inner>
                <span ref="prefix" :style="prefixStyle"> +52 </span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-6"></v-divider>

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="form.is_payment_user_same_as_buyer"
              label="El usuario de pagos es el mismo que el comprador"
            ></v-checkbox>
          </v-col>
        </v-row>

        <div v-if="!form.is_payment_user_same_as_buyer">
          <h4>Usuario de Pagos (Opcional)</h4>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.payment_user_name"
                label="Nombre completo del usuario de pagos"
                :rules="
                  !form.is_payment_user_same_as_buyer ? rules.required : []
                "
                :disabled="form.is_payment_user_same_as_buyer"
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.payment_user_last_name"
                label="Apellido del usuario de pagos"
                :rules="
                  !form.is_payment_user_same_as_buyer ? rules.required : []
                "
                :disabled="form.is_payment_user_same_as_buyer"
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.payment_user_email"
                label="Email del usuario de pagos"
                :rules="!form.is_payment_user_same_as_buyer ? rules.email : []"
                :disabled="form.is_payment_user_same_as_buyer"
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.payment_user_phone"
                label="Teléfono del usuario de pagos"
                :rules="!form.is_payment_user_same_as_buyer ? rules.phone : []"
                :disabled="form.is_payment_user_same_as_buyer"
                filled
                autocomplete="off"
                maxlength="10"
              >
                <template v-slot:prepend-inner>
                  <span style="margin-top: 3px; display: inline-block">
                    +52
                  </span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </div>

        <ErrorMessage v-if="errorMessage" :errorMessage="errorMessage" />

        <v-row>
          <v-col cols="6" md="6" offset="3">
            <v-btn
              block
              elevation="2"
              outlined
              rounded
              large
              :class="!valid ? 'btn-continue-disabled' : 'btn-continue'"
              @click="handleSubmit"
              :disabled="!valid"
            >
              Continuar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import CustomerUserService from "@/services/customerUserService";
import ErrorMessage from "@/components/register/ErrorMessage";

export default {
  name: "step-4",

  components: {
    ErrorMessage,
  },

  data() {
    return {
      form: {
        buyer_name: "",
        buyer_last_name: "",
        buyer_email: "",
        buyer_phone: "",
        is_payment_user_same_as_buyer: false,
        payment_user_name: "",
        payment_user_last_name: "",
        payment_user_email: "",
        payment_user_phone: "",
      },
      valid: false,
      isFocused: false,
      rules: {
        required: [(v) => !!v || "El campo es requerido"],
        email: [
          (v) => !!v || "El campo es requerido",
          (v) =>
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
              v
            ) || "Debe ingresar un correo valido",
        ],
        phone: [
          (v) => !!v || "El campo es requerido",
          (v) => v.length === 10 || "El número debe tener al menos 10 digitos ",
          (v) => /^[0-9]+$/.test(v) || "Solo se permiten números",
        ],
      },
      errorMessage: "",
    };
  },
  computed: {
    prefixStyle() {
      return {
        marginTop: this.isFocused ? "12px" : "3px",
        transition: "margin-top 0.3s ease-in-out",
      };
    },
  },

  watch: {
    "form.is_payment_user_same_as_buyer"(isSame) {
      if (isSame) {
        this.form.payment_user_name = this.form.buyer_name;
        this.form.payment_user_last_name = this.form.buyer_last_name;
        this.form.payment_user_email = this.form.buyer_email;
        this.form.payment_user_phone = this.form.buyer_phone;
      }
    },
    "form.buyer_name"(newVal) {
      if (this.form.is_payment_user_same_as_buyer) {
        this.form.payment_user_name = newVal;
      }
    },
    "form.buyer_last_name"(newVal) {
      if (this.form.is_payment_user_same_as_buyer) {
        this.form.payment_user_last_name = newVal;
      }
    },
    "form.buyer_email"(newVal) {
      if (this.form.is_payment_user_same_as_buyer) {
        this.form.payment_user_email = newVal;
      }
    },
    "form.buyer_phone"(newVal) {
      if (this.form.is_payment_user_same_as_buyer) {
        this.form.payment_user_phone = newVal;
      }
    },
  },
  methods: {
    onFocus() {
      this.isFocused = true;
    },
    async handleSubmit() {
      this.$refs.form.validate();
      if (!this.valid) {
        this.errorMessage = "Por favor, complete todos los campos requeridos.";
        return;
      }
      this.errorMessage = "";

      // Construir el payload para la API
      let payload = {
        buyer_user: {
          name: this.form.buyer_name,
          last_name: this.form.buyer_last_name,
          email: this.form.buyer_email,
          phone: "52" + this.form.buyer_phone,
        },
        is_payment_user_same_as_buyer: this.form.is_payment_user_same_as_buyer,
      };

      // Si el usuario de pagos es diferente al comprador, incluirlo en el payload
      if (!this.form.is_payment_user_same_as_buyer) {
        // Validar que se hayan completado los campos del usuario de pagos
        if (
          !this.form.payment_user_name ||
          !this.form.payment_user_last_name ||
          !this.form.payment_user_email ||
          !this.form.payment_user_phone
        ) {
          this.errorMessage =
            "Complete todos los campos del usuario de pagos o marque la casilla si es el mismo que el comprador.";
          return;
        }

        payload.payment_user = {
          name: this.form.payment_user_name,
          last_name: this.form.payment_user_last_name,
          email: this.form.payment_user_email,
          phone: "52" + this.form.payment_user_phone,
        };
      }

      this.$emit("handleLoading", true);

      const response = await CustomerUserService.create(payload);
      const status = response.status;
      const result = await response.json();

      this.$emit("handleLoading", false);

      switch (status) {
        case 200:
          this.$emit("saveStep", "step_4");
          this.$router.push({
            path: "/register/success",
            params: { email: this.form.buyer_email },
          });
          break;
        case 422:
          // show validation errors from API or fallback message
          this.errorMessage =
            result.msg || result.message || "Verifique los datos";
          break;
        case 500:
        case 403:
          this.errorMessage = result.msg;
          break;
      }
    },
  },
};
</script>

<style>
.btn-continue {
  background: #1d1d1f;
  color: #fff !important;
  border-color: #1d1d1f;
  text-transform: capitalize !important;
  padding: 1em !important;
}
</style>
